module.exports = __webpack_public_path__ + "static/media/pre.5850530b.svg";